import { IListing } from '@travelnest/typewriter';

import { _404 } from './handlers';
import { IConfiguredHttp } from './http';

export interface IListingsApi {
	getByPropertyId: (id: string) => Promise<IListing[]>;
	getByListingId: (id: string) => Promise<IListing>;
	update(listing: IListing): Promise<IListing>;
}

const listingsApiFactory = (http: IConfiguredHttp, prefix = ''): IListingsApi => ({
	getByPropertyId(id) {
		return http.get(`${prefix}/property/${id}`).catch(_404([]));
	},
	getByListingId(id) {
		return http.get(`${prefix}/${id}`);
	},
	update(listing) {
		return http.put(`${prefix}/${listing.id}`, listing);
	}
});

export default listingsApiFactory;
